import MindYetiStarSvg from './component.jsx'
export default MindYetiStarSvg
